import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { FloatingAddButton } from '../FloatingAddButton';
import { QuickAddProspectModal } from '../QuickAddProspectModal';

export const Layout = () => {
  const [showQuickAdd, setShowQuickAdd] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const location = useLocation();

  const handleProspectAdded = () => {
    window.dispatchEvent(new CustomEvent('prospect-added'));
  };

  return (
    <div className="flex h-screen bg-[#F8F9FA]">
      <Sidebar collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onMenuClick={() => setSidebarCollapsed(!sidebarCollapsed)} />
        
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>

      <FloatingAddButton onClick={() => setShowQuickAdd(true)} />
      <QuickAddProspectModal 
        open={showQuickAdd} 
        onClose={() => setShowQuickAdd(false)}
        onProspectAdded={handleProspectAdded}
      />
    </div>
  );
};
